import { create } from "zustand";
import { getResumeFiles } from "@/services/attachmentManager";
import { getIndustryConfigKV, getUserOnlineResume } from "@/services/onlineResume";
export const useResumeFile = create((set) => {
    /** 获取附件简历列表 */
    const getResumeList = async () => {
        try {
            const response = await getResumeFiles();
            if (response && response.code === 0) {
                // 把isOpen===1的放在前面
                const list = response?.data?.list?.sort((a, b) => (b.isOpen - a.isOpen));
                set({ resumeList: list });
            }
        }
        finally {
            set({ loading: false });
        }
    };
    /** 获取行业配置 */
    const getAllIndustryPC = async () => {
        try {
            const response = await getIndustryConfigKV();
            if (response && response.code === 0) {
                set({ allIndustryPC: response?.data });
            }
        }
        catch (err) {
            console.log(err, 'getSystemConfigKV');
        }
    };
    /** 获取在线简历信息 */
    const getOnlineInfo = async () => {
        try {
            const response = await getUserOnlineResume();
            if (response && response.code === 0) {
                set({ onlineInfo: response?.data });
            }
        }
        finally {
            set({ infoLoading: false });
        }
    };
    const store = {
        loading: true,
        infoLoading: true,
        // 状态数据
        resumeList: null,
        onlineInfo: null,
        allIndustryPC: null,
        editing: {
            isEditing: false,
            value: null
        },
        // 操作方法
        getResumeList,
        getOnlineInfo,
        getAllIndustryPC,
        setEditing: (editing) => set({ editing }),
    };
    return store;
});
